<form #form="ngForm">
    <div *ngIf="(formulaireOmService.paramOM) as paramOM; else loading">
            <mat-card>
                <mat-card-title>
                    <span [translate]="'admin.parametres.formulaire.om.parametrage'"></span>
                </mat-card-title>
                <mat-card-content>
                    <div class="row">
                        <custom-input
                                ngDefaultControl
                                id="actif"
                                name="actif"
                                [ngModel]="paramOM.actif"
                                [(customModel)]="paramOM.actif"
                                customType="checkbox"
                                libelle="admin.parametres.formulaire.om.actif"
                                postLibelle="admin.parametres.formulaire.om.actifPost"
                        ></custom-input>
                    </div>
                </mat-card-content>
            </mat-card>

            <mat-card>
                <mat-card-title>
                    <span [translate]="'admin.parametres.formulaire.om.generalite'"></span>
                </mat-card-title>
                <mat-card-content>
                    <div class="row">
                        <custom-input
                                ngDefaultControl
                                id="mIBShow"
                                name="mIBShow"
                                [ngModel]="paramOM.mibshow"
                                [(customModel)]="paramOM.mibshow"
                                customType="checkbox"
                                libelle="admin.parametres.formulaire.om.imputation"
                                postLibelle="admin.parametres.formulaire.om.imputationPost"
                        ></custom-input>
                        <custom-input
                                ngDefaultControl
                                id="plageHoraireShow"
                                name="plageHoraireShow"
                                [ngModel]="paramOM.plageHoraireShow"
                                [(customModel)]="paramOM.plageHoraireShow"
                                customType="checkbox"
                                libelle="admin.parametres.formulaire.om.plageHoraire"
                                postLibelle="admin.parametres.formulaire.om.plageHorairePost"
                        ></custom-input>
                    </div>
                    <div class="row">
                        <custom-input
                                ngDefaultControl
                                id="paysDestination"
                                name="paysDestination"
                                [ngModel]="paramOM.paysDestination"
                                [(customModel)]="paramOM.paysDestination"
                                customType="checkbox"
                                libelle="admin.parametres.formulaire.om.paysDestination"
                                postLibelle="admin.parametres.formulaire.om.paysDestinationPost"
                        ></custom-input>
                        <custom-input
                                ngDefaultControl
                                id="complementDestination"
                                name="complementDestination"
                                [ngModel]="paramOM.complementDestination"
                                [(customModel)]="paramOM.complementDestination"
                                customType="checkbox"
                                libelle="admin.parametres.formulaire.om.lieu"
                                postLibelle="admin.parametres.formulaire.om.lieuPost"
                        ></custom-input>
                    </div>
                    <div class="row">
                        <custom-input
                                ngDefaultControl
                                id="dateObligatoire"
                                name="dateObligatoire"
                                [ngModel]="paramOM.dateObligatoire"
                                [(customModel)]="paramOM.dateObligatoire"
                                customType="checkbox"
                                libelle="admin.parametres.formulaire.om.dateObligatoire"
                                postLibelle="admin.parametres.formulaire.om.dateObligatoirePost"
                                (customModelChange)="onDateObligatoireChange()"
                        ></custom-input>
                        <custom-input
                                ngDefaultControl
                                id="isDateModifiable"
                                name="isDateModifiable"
                                [ngModel]="paramOM.dateModifiable"
                                [(customModel)]="paramOM.dateModifiable"
                                customType="checkbox"
                                libelle="admin.parametres.formulaire.om.dateModifiable"
                                postLibelle="admin.parametres.formulaire.om.dateModifiablePost"
                                [disabled]="paramOM.dateObligatoire"
                        ></custom-input>
                    </div>
                    <div class="row">
                        <custom-input
                                ngDefaultControl
                                customType="select"
                                [(ngModel)]="paramOM.idTraiteAvantLe"
                                [selectOptions]="idTraiteAvantLeOptionListe"
                                libelle="admin.parametres.formulaire.om.valeurDefaut"
                                name="idTraiteAvantLe"
                                optionDisplay="libelle"
                                optionValue="value"
                                [hasForcedError]="isValeurDefautError(paramOM)"
                                [required]="!paramOM.dateModifiable"
                        ></custom-input>
                        <custom-input
                                ngDefaultControl
                                customType="number"
                                [(ngModel)]="paramOM.nbRepartitions"
                                libelle="admin.parametres.formulaire.om.repartitions"
                                name="nbRepartitions"
                                [min]="0"
                                [postTooltip]="'admin.parametres.formulaire.om.illimite' | translate"
                        ></custom-input>
                    </div>
                </mat-card-content>
            </mat-card>

            <mat-card>
                <mat-card-title>
                    <span [translate]="'admin.parametres.formulaire.om.gestionVoyage'"></span>
                </mat-card-title>
                <mat-card-content>
                    <div class="row">
                        <custom-input
                                ngDefaultControl
                                customType="select"
                                [(ngModel)]="paramOM.idModeParticipant"
                                [selectOptions]="idModeParticipantOptionListe"
                                libelle="admin.parametres.formulaire.om.participantAutorisation"
                                name="idModeParticipant"
                                optionDisplay="libelle"
                                optionValue="value"
                                (onChange)="onIdModeParticipantChange(paramOM.idModeParticipant)"
                        ></custom-input>
                        <custom-input
                                ngDefaultControl
                                customType="select"
                                [(ngModel)]="paramOM.idMailParticipant"
                                [selectOptions]="formulaireOmService.messageNotificationListe"
                                libelle="admin.parametres.formulaire.om.mail"
                                name="idMailParticipant"
                                optionDisplay="titre"
                                optionValue="idMessage"
                                [disabled]="paramOM.idModeParticipant === IdModeParticipantOption.AUCUN || paramOM.idModeParticipant === IdModeParticipantOption.EXTERNES_UNIQUEMENT"
                        ></custom-input>
                    </div>
                    <div class="row">
                        <custom-input
                                ngDefaultControl
                                id="collabNotPartAlowwed"
                                name="collabNotPartAlowwed"
                                [ngModel]="paramOM.collabNotPartAlowwed"
                                [(customModel)]="paramOM.collabNotPartAlowwed"
                                customType="checkbox"
                                libelle="admin.parametres.formulaire.om.participation"
                                postLibelle="admin.parametres.formulaire.om.participationPost"
                                [disabled]="paramOM.idModeParticipant === IdModeParticipantOption.AUCUN"
                        ></custom-input>
                        <custom-input
                                ngDefaultControl
                                id="creationForParticipant"
                                name="creationForParticipant"
                                [ngModel]="paramOM.creationForParticipant"
                                [(customModel)]="paramOM.creationForParticipant"
                                customType="checkbox"
                                libelle="admin.parametres.formulaire.om.duplication"
                                postLibelle="admin.parametres.formulaire.om.duplicationPost"
                                [disabled]="paramOM.idModeParticipant === IdModeParticipantOption.AUCUN || paramOM.idModeParticipant === IdModeParticipantOption.EXTERNES_UNIQUEMENT"
                        ></custom-input>
                    </div>
                    <div class="row">
                        <custom-input
                                ngDefaultControl
                                id="emissionForParticipant"
                                name="emissionForParticipant"
                                [ngModel]="paramOM.emissionForParticipant"
                                [(customModel)]="paramOM.emissionForParticipant"
                                customType="checkbox"
                                libelle="admin.parametres.formulaire.om.autoriserDuplication"
                                postLibelle="admin.parametres.formulaire.om.autoriserDuplicationPost"
                                [disabled]="!paramOM.creationForParticipant"
                        ></custom-input>
                        <custom-input
                                ngDefaultControl
                                id="dateTransportIncluse"
                                name="dateTransportIncluse"
                                [ngModel]="paramOM.dateTransportIncluse"
                                [(customModel)]="paramOM.dateTransportIncluse"
                                customType="checkbox"
                                libelle="admin.parametres.formulaire.om.dateTransport"
                                postLibelle="admin.parametres.formulaire.om.dateTransportPost"
                        ></custom-input>
                    </div>
                </mat-card-content>
            </mat-card>

            <mat-card>
                <mat-card-title>
                    <span [translate]="'admin.parametres.formulaire.om.gestionFrais'"></span>
                </mat-card-title>
                <mat-card-content>
                    <div class="row">
                        <custom-input
                                ngDefaultControl
                                id="multiNdfAllowed"
                                name="multiNdfAllowed"
                                [ngModel]="paramOM.multiNdfAllowed"
                                [(customModel)]="paramOM.multiNdfAllowed"
                                customType="checkbox"
                                libelle="admin.parametres.formulaire.om.saisie"
                                postLibelle="admin.parametres.formulaire.om.saisiePost"
                        ></custom-input>
                        <custom-input
                                ngDefaultControl
                                customType="select"
                                [(ngModel)]="paramOM.idModeDegrevement"
                                [selectOptions]="idModeDegrevementOptionListe"
                                libelle="admin.parametres.formulaire.om.indemniteDegrevement"
                                name="idModeDegrevement"
                                optionDisplay="libelle"
                                optionValue="value"
                        ></custom-input>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <floating-button [listeActions]="listeActions" [isPending]="formulaireOmService.isSaving"></floating-button>
</form>

<!--Affiché si on a pas encore le modèle-->
<ng-template #loading>
    <please-wait class="content"></please-wait>
</ng-template>